import React, { PropsWithChildren } from 'react'
import { Grid, Box } from '@material-ui/core'
import styled from 'styled-components'

import welcome from 'src/assets/images/welcome.png'
import { Illustration, LogoIcon } from 'src/components/dataDisplay/Illustration'

const FullScreenContainer = styled(Grid)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: cover;
  background-position: center;
  background-image: url(${welcome});
`

const StyledLogo = styled(Illustration)`
  position: absolute;
  left: ${({ theme }) => theme.spacing(8)}px;
  top: ${({ theme }) => theme.spacing(11)}px;
`

export type FullScreenBackdropDialogProps = PropsWithChildren<{}>

const FullScreenBackdropDialog = ({
  children,
}: FullScreenBackdropDialogProps) => (
  <FullScreenContainer container>
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <StyledLogo type={LogoIcon.LesMillsWhite} />
      {children}
    </Box>
  </FullScreenContainer>
)

export default FullScreenBackdropDialog
